export const DEFAULT_VALUE = '-';
export const optionalValue = (value, defaultValue = DEFAULT_VALUE) => value ?? defaultValue;
